<div class="dialog-header">
  <div class="header-title">
		<span class="assigned-to-label">
            <ng-container *ngIf="buttonLabel === 'Save'">{{ getHeaderText() }}, To: {{task?.assignedUser?.name}}</ng-container>
            <ng-container *ngIf="buttonLabel === 'Create' && !task?.checkitemIds">Create Task</ng-container>
            <ng-container *ngIf="buttonLabel === 'Create' && task?.checkitemIds">Create Service Order</ng-container>
		</span>
  </div>

    <span class="buttons-block">
                <button class="header-button" mat-button (click)="toggleSample()"
                        pTooltip="{{tempTask.isSample ? 'This is sample' : 'Make it sample'}}" tooltipPosition="bottom"
                        *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'"
                        [disabled]="!canEditField('isSample')"
                        [ngClass]="{'active-sample': tempTask.isSample}"
                        tabindex="-1">
                    <mat-icon>style</mat-icon>
                </button>
                <button class="header-button lock-button" mat-button (click)="toggleLock()"
                        pTooltip="{{tempTask.isLock ? 'Locked' : 'Lock this task'}}" tooltipPosition="bottom"
                        *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK' && this.tempTask.id"
                        [ngClass]="{'active-sample': tempTask.isLock}"
                        tabindex="-1"
                >
                  <mat-icon>{{tempTask.isLock ? 'lock' : 'lock_open'}}</mat-icon>
                </button>
                <button *ngIf="buttonLabel === 'Save'" mat-button class="header-button comments-button" (click)="openComments()"
                        pTooltip="View Discussion" tooltipPosition="bottom"
                        tabindex="-1">
                    <mat-icon>chat</mat-icon>
                </button>
                <button class="header-button" mat-button (click)="openOrderPDF()"
                        *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK' && this.tempTask.id"
                        tabindex="-1">
                    <mat-icon>print</mat-icon>
                </button>
    </span>
  <button mat-button class="close-button-container" disableRipple="true" (click)="closeDialog()">
    <mat-icon>clear</mat-icon>
  </button>
</div>


<div class="edit-block">

  <ng-container *ngIf="projectsLoading">
    <lib-progress-spinner></lib-progress-spinner>
  </ng-container>

  <form #userEditForm="ngForm" *ngIf="!projectsLoading">
    <div class="form-block">
      <div class="form-row">
        <div class="row-label">
          Assigned To:
        </div>

        <p-dropdown [ngModelOptions]="{standalone: true}" [options]="users" [(ngModel)]="selectedUser"
                    optionLabel="name" placeholder="User" [virtualScroll]="true" [itemSize]="31" [filter]="true"
                    filterBy="name,username,shortCode,phone,email" [disabled]="!canEditField('assignedUser')">

          <ng-template let-item pTemplate="selectedItem" *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'">
            <ng-container
              *ngIf="item.roles">{{item.roles[0]?.name === 'Service Department' ? item.roles[0]?.name + ' (' + item.shortCode + ')' : item.name}}
            </ng-container>
            <ng-container
              *ngIf="!item.roles">{{item.name}}
            </ng-container>
          </ng-template>

        </p-dropdown>
      </div>
      <div class="form-row">
        <div class="row-label">
          Project:
        </div>
        <p-dropdown [ngModelOptions]="{standalone: true}" [options]="shortProjects"
                    [(ngModel)]="selectedShortProj" optionLabel="name" placeholder="Project" [virtualScroll]="true"
                    [itemSize]="31" [filter]="true" [showClear]="true"
                    filterBy="name,number" [disabled]="!canEditField('project')">
        </p-dropdown>
      </div>

      <div class="form-row">
        <div class="row-label">
          Deadline:
        </div>
        <p-calendar [(ngModel)]="tempTask.deadline" [icon]="'pi pi-calendar'"
                    [panelStyleClass]="'task-time-panel'" [showIcon]="true" [ngModelOptions]="{standalone: true}"
                    [tabindex]="-1" [readonlyInput]="false" [showOnFocus]="false" [touchUI]="true" name="date"
                    (onShow)="onShown()" (onMonthChange)="monthChanged($event)" [disabled]="!canEditField('deadline')">
          <ng-template pTemplate="date" let-date *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'">
            <span>{{date.day}}</span>
            <div class="dots-block">
              <div class="dot-activity" *ngFor="let val of activityDots.get(date.day + '')"
                   pTooltip="{{val.val}}" tooltipPosition="bottom" style.background-color="#{{val.color}}">
              </div>
            </div>
          </ng-template>
        </p-calendar>
      </div>

      <div class="form-row text-block" *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'">
        <div class="row-label">

          Delivery Instructions:
        </div>
        <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" [placeholder]="'Message'"
               [(ngModel)]="tempTask.deliveryInstructions" [disabled]="!canEditField('deliveryInstructions')">
      </div>
      <div class="form-row text-block">
        <div class="row-label">
          Notes:
        </div>
        <textarea #taskTextArea matInput [(ngModel)]="tempTask.text" name="message" placeholder="Message"
                  class="text-area-task-block" [mention]="users"
                  [mentionConfig]="{triggerChar:'@', maxItems:25, labelKey:'username', mentionSelect: onMentionSelect}"
                  tabindex="1" [disabled]="!canEditField('text')"></textarea>
      </div>

      <div class="form-row checkitems-block" *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK'">
        <div class="tasks-container">
          <div class="nfs-blocks">
            <div class="nfs-block" *ngFor="let clientNf of tempTask?.clientNotifications">
              <app-client-message [clientNf]="clientNf"
                                  [ngClass]="{'resolved-nfs': clientNf.resolvedTime}"
                                  [fromProj]="true" (deleteMsg)="deleteMsg($event)">
              </app-client-message>
            </div>
          </div>
          <div class="nfs-block no-history"
               *ngIf="!tempTask?.clientNotifications || tempTask?.clientNotifications.length === 0">
            No Messages
          </div>

          <button mat-button class="create-message-button" (click)="createMessage()">
            <mat-icon>add</mat-icon>
            <div class="button-title">Create Client Notification</div>
          </button>
        </div>
      </div>
    </div>
  </form>

  <div class="right-items-block" *ngIf="!projectsLoading">
    <div class="form-row checkitems-block"
         *ngIf="tempTask.clazz === 'SERVICE_ORDER_TASK' || tempTask.clazz === 'WORK_ORDER_TASK'">
      <app-task-checkitem [tempTask]="tempTask" [projectId]="projectId" [projectName]="projectName" [users]="users" [currentUser]="currentUser">
      </app-task-checkitem>
    </div>

    <div class="form-row files-block">
      <app-task-files [task]="task" [projectId]="projectId" (newFilesEmit)="newFilesEmit($event)"></app-task-files>
    </div>

  </div>

</div>

<div class="save-btn-block" *ngIf="!projectsLoading">
  <div class="sav-btn-bloock">
    <div class="comments-box">
        <div class="row-label">
          <span class="date-label" *ngIf="task?.created">Created: {{task.created | date: 'MMM d, y'}}</span>
          <span class="date-label" *ngIf="task?.lastUpdatedDate">Updated: {{task.lastUpdatedDate | date: 'MMM d, y'}}</span>
          <span class="date-label" *ngIf="task?.createdByTagName && task.clazz === 'WORK_ORDER_TASK'">Associated tags: {{task.createdByTagName.split(',').join(', ')}}</span>
        </div>
    </div>

    <button mat-button class="save-btn" (click)="saveTask()" [disabled]="!selectedUser  || loadingSpinner"
            tabindex="1" type="submit" [ngClass]="{'disabled-button': !selectedUser || loadingSpinner}">

      <span *ngIf="!loadingSpinner">{{buttonLabel}}</span>
      <lib-mini-progress-spinner *ngIf="loadingSpinner"></lib-mini-progress-spinner>
    </button>

    <div class="flex-box">
      <button *ngIf="buttonLabel === 'Save'" mat-button class="delete-task-button" (click)="deleteTask()" [disabled]="!canDeleteTask()">
        <mat-icon *ngIf="!deleteLoadingSpinner">delete</mat-icon>
        <lib-mini-progress-spinner *ngIf="deleteLoadingSpinner"></lib-mini-progress-spinner>
      </button>

      <p-confirmDialog appendTo="body" icon="pi pi-trash" styleClass="task-delete-dialog">
      </p-confirmDialog>
    </div>

  </div>
</div>
